import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import NavBar from './components/organisms/NavBar';
import AppRoutes from './App.Routes';
import { ToastProvider } from './utils/ToastContext';
import ToastContainer from './components/organisms/ToastContainer';
import { ThunkDispatch, Action } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { checkAuthState } from './redux/slices/authSlice';
import { RootState } from "./redux/rootReducer"; // Adjust as needed
import { ToastContainer as ReactToastifContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const AppContent: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch<RootState, void, Action>>();
  const location = useLocation();

  useEffect(() => {
    // Skip auth check for public pages
    const publicPaths = ['/organization-setup', '/login', '/password-reset', '/authcallback'];
    if (!publicPaths.includes(location.pathname)) {
      console.log("Checking user authentication state...");
      dispatch(checkAuthState());
    }
  }, [dispatch, location]);

  return (
    <>
      <NavBar />
      <AppRoutes />
    </>
  );
};

const App: React.FC = () => {
  return (
    <ToastProvider>
      <ToastContainer />
      <Router>
        <AppContent />
      </Router>
      <ReactToastifContainer />
    </ToastProvider>
  );
};

export default App;
